module.exports = __webpack_public_path__ + "productivity1.webp?0557e7592ee24ecd2022a39305e525f7";